import { render, staticRenderFns } from "./addTag.vue?vue&type=template&id=dd4fcdd4&"
import script from "./addTag.vue?vue&type=script&lang=js&"
export * from "./addTag.vue?vue&type=script&lang=js&"
import style0 from "./addTag.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports